import React, { useState } from 'react';
import { Typography, Button, Grid, TextField } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

import BaseSheet from '../Common/Layout/BaseSheet';
import { Alert } from '@mui/material';
import BaseDialog from '../Common/BaseDialog';
import SchoolSelector from '../Common/Selectors/SchoolSelector';
import { getStyles } from './styles';
import EvaluatorService from '../../services/EvaluatorService';
import { SiteDTO } from '@beable/roster-backend-client-v1';

const StyledSchoolSelector = styled(SchoolSelector)(({ theme }) => getStyles(theme).provisionSelector);
interface PersonalizeSheetProps {
    site: SiteDTO | undefined;
}
export default function PersonalizeSheet({ site }: PersonalizeSheetProps) {
    const [schoolId, setSchoolId] = useState<string>();
    const [userName, setUserName] = useState<string>();
    const [isError, setIsError] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const theme = useTheme();
    const styles = getStyles(theme);
    const handleSave = async () => {
        setIsSaving(true);
        setIsError(false);
        if (!site?.id || (!schoolId && !userName)) {
            return;
        }
        const response = await EvaluatorService.personalizeEvaluatorAccounts(site.id, site.subdomain, schoolId, userName);
        if (!response) {
            setIsError(true);
            setIsSaving(false);
            return;
        } else {
            setIsSuccess(true);
        }
         
        setIsSaving(false);
    }
    const isSaveDisabled = (): boolean => {
        return (!schoolId && !userName) || isSaving;
    }
    const clearAlertState = (): void => {
        setIsError(false);
        setIsSuccess(false);
    }
    const getDialogText = (): string => {
        if (isError) {
            return "Error submitting personalization request. Please Try Again!";
        }
        if (isSuccess) {
            return "Personalization request submitted successfully!"
        }

        return "";
    }

    return (
        <BaseSheet id='personalization-request-container'>
            <Typography variant='h6' sx={styles.header}>
                Personalize Evaluator Account
            </Typography>
            <Typography
                variant="body1"
                component="p"
                sx={styles.subheader}
            >
                Select a school OR enter a username to submit your request <br />
            </Typography>
            <StyledSchoolSelector
                siteId={site?.id || 0}
                schoolId={schoolId}
                onChange={(schoolId: string) => { setSchoolId(schoolId) }}
                allOption={false}
                disabled={!site?.id}
                variant='outlined'
            />
            <div> OR </div>
            <Grid>
                <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    data-testid="input-username"
                    id="username"
                    label="User Name"
                    name="userName"
                    onChange={(e: any) => {
                        setUserName(e.target.value);
                    }}
                    slotProps={{
                        htmlInput: { style: { textTransform: "lowercase" } }
                    }}
                />
            </Grid>
            <Typography
                variant="body1"
                component="p"
                sx={styles.footnote}
            >
                **For given evaluator account use first initial of the first name + complete last name <br />
            </Typography>
            <Grid container sx={{
                justifyContent: 'space-between'
            }}>
                <Button
                    variant='contained'
                    color='primary'
                    aria-label='save'
                    title='Save'
                    sx={styles.button}
                    onClick={handleSave}
                    disabled={isSaveDisabled()}
                >
                    Submit Request
                </Button>
            </Grid>
            <BaseDialog
              open={isError || isSuccess}
              showCloseIcon={false}
              showCloseButton={true}
              onClose={clearAlertState}
            >
                <Alert severity={isError ? "error" : "success"} sx={styles.alert}>
                    {getDialogText()}
                </Alert>
            </BaseDialog>
        </BaseSheet>
    );
}